import styled from 'foundations-theming/utils';
import LoadingMerchCardCTAs from '../../components/merch-card/LoadingMerchCardCTAs';
import { LoadableWrapper } from '../common/LoadableWrapper';
import { useRecommendedSalesHubProCTAsProps } from './useRecommendedSalesHubProCTAsProps';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledRecommendedCTAs = styled.div.withConfig({
  displayName: "RecommendedSalesHubProCTAsContainer__StyledRecommendedCTAs",
  componentId: "sc-17jw6g1-0"
})(["display:flex;flex-direction:row;flex-wrap:wrap;button{background:none;border:none;color:#0091ae;padding:5px 10px 5px 0px;}button:not(:first-child){margin-bottom:8px;padding-left:10px;}button:not(:last-child){border-right:1px solid #cbd6e2;border-radius:0;}button:hover{background:none;text-decoration:underline;color:#0091ae;}"]);
const RecommendedSalesHubProCTAsContainer = props => {
  const commonAuthProps = useRecommendedSalesHubProCTAsProps(Object.assign({}, props));
  return /*#__PURE__*/_jsx(StyledRecommendedCTAs, {
    children: /*#__PURE__*/_jsx(LoadableWrapper, {
      loader: () => import( /* webpackChunkName: "authed-chunk" */`pricing-pages-ui/components/auth-cta-motions/AuthedCTAs`),
      componentProps: Object.assign({}, props, commonAuthProps),
      LoadingComponent: LoadingMerchCardCTAs
    })
  });
};
export default RecommendedSalesHubProCTAsContainer;